import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  version!: string;
  copyright!: string;
  envName!: string;

  constructor() { }

  ngOnInit(): void {
    this.version = environment.release_version;
    this.copyright = environment.copyright;
    this.envName = environment.env_name;
  }
}
